<template>
  <div>
    <img
        :src="require(`../../../../assets/images/error@2x.jpg`)"
        :srcset="`${require(`../../../../assets/images/error@1x.jpg`)} 1x, ${require(`../../../../assets/images/error@2x.jpg`)} 2x, ${require(`../../../../assets/images/error@3x.jpg`)} 3x, ${require(`../../../../assets/images/error@4x.jpg`)} 4x`"
    />

    <div class="modal-body">
      <h2>{{ 'Oops, Something Went Wrong' | trans }}</h2>
      <p>{{ 'It looks like there was an issue. We dispatched our seal team to solve this issue.' | trans }}</p>
      <p>
        <strong>{{ 'No Credit has been deducted.' | trans  }}</strong>
      </p>
      <p>
        {{ 'Please try again later.' | trans  }}
      </p>
    </div>
  </div>
</template>
<script>
import store from '../../../../mixins/store.mixin';

export default {
  name: 'GenericJobError',
  props: {},
  components: {},
  mixins: [store],
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>
